// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Recognition20 from './Recognition20';
import Recognition20Filled from './Recognition20Filled';
import Recognition20Circle from './Recognition20Circle';
import Recognition24 from './Recognition24';
import Recognition24Filled from './Recognition24Filled';
import Recognition24Circle from './Recognition24Circle';
import Recognition40 from './Recognition40';
import Recognition40Filled from './Recognition40Filled';
import Recognition48 from './Recognition48';
import Recognition48Filled from './Recognition48Filled';

type RecognitionProps = {
    variation:
        | '20'
        | '20Filled'
        | '20Circle'
        | '24'
        | '24Filled'
        | '24Circle'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Recognition20,
    Recognition20Filled,
    Recognition20Circle,
    Recognition24,
    Recognition24Filled,
    Recognition24Circle,
    Recognition40,
    Recognition40Filled,
    Recognition48,
    Recognition48Filled,
};

const Recognition: FC<RecognitionProps> = ({ variation, ...props }) => {
    const variationKey = `Recognition${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Recognition" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Recognition;
